import Image from 'next/image';
import React, { ChangeEvent, KeyboardEvent, useEffect, useState } from 'react';
import { TextInputType } from '../../../FormFields/shared';
import searchIcon from '@/images/search-icon.svg';
import rightArrowIcon from '@/images/right-filled-bullet.svg';

interface SearchInputProps {
  hideSubmitButton?: boolean;
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

export function SearchInput({
  hideSubmitButton = false,
  value,
  onChange,
  onSubmit
}: SearchInputProps) {
  const [searchValue, setSearchValue] = useState('');
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.currentTarget.value;
    setSearchValue(newValue);
    onChange(newValue.trim());
  };
  const handleKeydown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (/^(Numpad)?Enter/.test(event.code)) {
      onSubmit();
    }
  };

  useEffect(() => setSearchValue(value), [value]);

  return (
    <div className="relative h-full w-full">
      <div className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[0px] leading-none">
        <Image alt="" src={searchIcon} width={22} height={22} />
      </div>
      <input
        data-testid="search-box"
        name="subject"
        type={TextInputType.SEARCH}
        inputMode="search"
        value={searchValue}
        onChange={handleChange}
        onKeyDown={handleKeydown}
        placeholder="Search a topic, tag, title..."
        className={`bg-transparent [&[data-autocompleted]]:!bg-transparent h-full w-full appearance-none !rounded-full border !border-teal !py-3 px-3 !pl-10 !text-base text-black outline-0 placeholder:!font-normal placeholder:text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-limegreen desktop:rounded-2xl [&:-webkit-autofill:focus]:transition-[background-color_600000s_0s,color_600000s_0s] [&:-webkit-autofill]:transition-[background-color_600000s_0s,color_600000s_0s] [&[type="search"]::-webkit-search-cancel-button]:appearance-none [&[type="search"]::-webkit-search-decoration]:appearance-none [&[type="search"]::-webkit-search-results-button]:appearance-none [&[type="search"]::-webkit-search-results-decoration]:appearance-none ${
          hideSubmitButton ? '!pr-6' : '!pr-12'
        }`}
        style={{
          WebkitAppearance: 'none'
        }}
      />
      {hideSubmitButton ? null : (
        <button
          data-testid="search-box-submit-button"
          type="button"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[0px] leading-none"
          onClick={onSubmit}
          aria-label="Submit search query using right arrow button"
          title="Submit search query"
        >
          <Image alt="" src={rightArrowIcon} width={32} height={32} />
        </button>
      )}
    </div>
  );
}
